<template>
  <div class="offers-table-list">
    <div class="offers-list__page offers-list-page">
      <div>
        <div class="offers-list">
          <div class="offers-table-list">
            <DataTableComponent />
          </div>
        </div>
        <span v-if="!isLoading && offers.length === 0">
          <OfferCardEmpty />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DataTableComponent from '@components/DataTableComponent.vue';
import { useOfferListStore } from '@stores/useOfferListStore';
import { storeToRefs } from 'pinia';
import OfferCardEmpty from './OfferCardEmpty.vue';

export default {
  components: {
    OfferCardEmpty,
    DataTableComponent,
  },
  setup() {
    const { isLoading, offers } = storeToRefs(useOfferListStore());
    return {
      isLoading,
      offers,
    };
  },
};
</script>
